import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { InteriorComponent, ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';

const addInteriorSuggestion = ({ coreApi, props }: BehaviorParameters) => {
  const interiorSuggestionEntity = coreApi
    .getServices()
    .productManager.createEntity(props.coreProductId);
  const section = coreApi.entities.findSelectedEntity();

  if (
    !interiorSuggestionEntity ||
    !section ||
    !coreApi.entities.isProductType(section, ProductType.IVAR_SECTION)
  ) {
    return;
  }

  const currentChildrenInSection = HierarchyUtils.descendants(section).filter(
    child =>
      child.hasComponent(InteriorComponent.id) || child.hasComponent(ComponentIds.DOOR_COMPONENT_ID)
  );
  coreApi.entities.deleteMultiple(currentChildrenInSection);

  const placementResult = coreApi.placementService.snapToTarget(interiorSuggestionEntity, section);
  if (placementResult?.placedEntity) {
    coreApi.placementService.dissolveEntity(placementResult.placedEntity);
  }
  return placementResult;
};

export default addInteriorSuggestion;
